export const acceptAction = 'transition/accept';
export const enquireAction = 'transition/enquire';
export const requestAction = 'transition/request-payment';
export const declineAction = 'transition/decline-by-provider';
export const newMessageAction = 'NEW_MESSAGE';
export const messageOpenedByCustomerEventType = 'messageOpenedByCustomerEventType';
export const messageOpenedByProviderEventType = 'messageOpenedByProviderEventType';
export const bookingOpenedByCustomerEventType = 'bookingOpenedByCustomerEventType';
export const bookingOpenedByProviderEventType = 'bookingOpenedByProviderEventType';



// WEBPACK FOOTER //
// ./src/util/eventsHelpers/constants.js